module.exports = __webpack_public_path__ + "static/media/rp.80c43083.svg";